module.exports = __webpack_public_path__ + "img/zh_yd.59cca2af.png";